import React, { useState, useEffect, useRef } from "react";
import "../styles/AdminMedia.css";

function AdminMedia() {
  const [mediaList, setMediaList] = useState([]);
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");
  const [modalImg, setModalImg] = useState(null);
  const fileInputRef = useRef();

  useEffect(() => {
    fetchMedia();
  }, []);

  const fetchMedia = async () => {
    setError("");
    try {
      const res = await fetch("https://alaiak.eus/api/alaiak/admin/media", { credentials: "include" });
      if (!res.ok) throw new Error("No autorizado o error de red");
      const data = await res.json();
      setMediaList(data);
    } catch (err) {
      setError(err.message);
    }
  };

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    setFile(selected);
    if (selected) {
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result);
      reader.readAsDataURL(selected);
    } else {
      setPreview(null);
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) return;
    setUploading(true);
    setError("");
    const formData = new FormData();
    formData.append("file", file);
    try {
      const res = await fetch("https://alaiak.eus/api/alaiak/admin/media", {
        method: "POST",
        body: formData,
        credentials: "include",
      });
      if (!res.ok) throw new Error("Error al subir imagen");
      setFile(null);
      setPreview(null);
      fileInputRef.current.value = "";
      await fetchMedia();
    } catch (err) {
      setError(err.message);
    } finally {
      setUploading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("¿Eliminar esta imagen?")) return;
    setError("");
    try {
      const res = await fetch(`https://alaiak.eus/api/alaiak/admin/media/${id}`, {
        method: "DELETE",
        credentials: "include",
      });
      if (!res.ok) throw new Error("Error al borrar imagen");
      await fetchMedia();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="admin-media-panel">
      <h2>Gestión de Imágenes</h2>
      <form onSubmit={handleUpload} className="admin-media-upload-form">
        <label className="custom-file-label">
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            ref={fileInputRef}
            disabled={uploading}
            style={{ display: "none" }}
          />
          <span className="custom-file-button">Seleccionar imagen</span>
        </label>
        <span className="custom-file-name">{file ? file.name : "Ningún archivo seleccionado"}</span>
        <button type="submit" disabled={uploading || !file}>
          {uploading ? "Subiendo..." : "Subir Imagen"}
        </button>
      </form>
      {preview && (
        <div style={{ marginBottom: "1.5rem", textAlign: "center" }}>
          <strong>Previsualización:</strong>
          <div>
            <img src={preview} alt="preview" style={{
              maxWidth: "220px",
              maxHeight: "180px",
              marginTop: "0.7rem",
              borderRadius: "8px",
              boxShadow: "0 2px 12px #1976d220"
            }} />
          </div>
        </div>
      )}
      {error && <div className="admin-media-error">{error}</div>}
      <div className="admin-media-list">
        {mediaList.length === 0 ? (
          <div className="admin-media-empty">
            <p>No hay imágenes subidas.</p>
          </div>
        ) : (
          <div className="admin-media-grid">
            {mediaList.map((m) => (
              <div key={m.id} className="admin-media-item">
                <img
                  src={`https://alaiak.eus${m.url}`}
                  alt={m.alt || "imagen"}
                />

                <div className="admin-media-caption">{m.alt}</div>
                <button onClick={() => handleDelete(m.id)} className="admin-media-delete">Borrar</button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminMedia;
